import { STORIES, STORIES_ALL } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './Stories'

export default withLocalization(Component, STORIES, {
  stories: STORIES_ALL,
})
